import React from 'react'
import {Form, Select} from 'antd'

const renderOptions = (list = []) => {
  return list.map((rec) => <Select.Option value={rec}>{rec}</Select.Option>)
}

export {renderOptions}
